import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from '@catawiki/cata-style';
import { AFFILIATE_PATH, NEW_LOT_PATH, SELLER_LANDING_PATH, SELLER_TERMS_PATH, SELLER_TIPT_PATH, SUITABLE_ITEMS_PATH, } from '../paths';
import { FooterColumn } from '../shared/FooterColumn';
import { useIsUserLoggedIn } from '../../../../shared/hooks/useIsUserLoggedIn';
import { useLocale } from '../../../../hooks/useLocale';
export const Sell = ({ showCategoryGuidelines }) => {
    const isLoggedIn = useIsUserLoggedIn();
    const { t } = useI18n();
    const locale = useLocale();
    const items = [
        {
            content: t('footer_link_how_to_sell'),
            link: isLoggedIn ? NEW_LOT_PATH(locale) : SELLER_LANDING_PATH(locale),
        },
        {
            content: t('footer_link_seller_tips'),
            link: SELLER_TIPT_PATH(locale),
        },
        ...(showCategoryGuidelines
            ? [
                {
                    content: t('category_guidelines'),
                    link: SUITABLE_ITEMS_PATH(locale),
                },
            ]
            : []),
        { content: t('seller_policy'), link: SELLER_TERMS_PATH(locale) },
        { content: t('affiliate_program'), link: AFFILIATE_PATH(locale) },
    ];
    return _jsx(FooterColumn, { title: t('footer_link_sell'), items: items });
};
//# sourceMappingURL=Sell.js.map